export const ALL_SERVICES = "embroidery,print";

export type ServiceType = "embroidery" | "print" | string;

const serviceTypeLookup: {
  [key: string]: "embroidery" | "print";
} = {
  EMBROIDERY: "embroidery",
  PRINT: "print",
};

export const serviceTypeToName = (id: string) => {
  return serviceTypeLookup[id];
};
